import "core-js/modules/es.object.to-string.js";
import { useAxeptio } from '@/composables/_next/useAxeptio';
import { useLocalization } from '~/composables/_next/useLocalization';
export function useIAdvize() {
  var _useNuxt2App = useNuxt2App(),
    $config = _useNuxt2App.$config,
    $sentry = _useNuxt2App.$sentry;
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale;
  var _useAxeptio = useAxeptio(),
    onConsent = _useAxeptio.onConsent;

  /**
   * Loads IAdvize script with fallback if loading fails.
   * @returns {Promise<boolean>} - Resolves to true if the script loaded successfully, false otherwise.
   */
  function loadIAdvize() {
    if (process.server) throw new Error('IAdvize is only available client side');
    var w = window;
    return new Promise(function (resolve) {
      try {
        var _w$iAdvizeInterface;
        // Check if script is already loaded
        if (document.getElementById('iadvize-script')) {
          if (w.iAdvizeInterface && typeof w.iAdvizeInterface.set === 'function') {
            resolve(true); // IAdvize is already loaded and functional
          } else {
            console.warn('IAdvize script loaded but API is unavailable');
            resolve(false); // Degraded mode: continue without IAdvize
          }
          return;
        }

        // Initialize IAdvize configuration
        w.iAdvizeInterface = (_w$iAdvizeInterface = w.iAdvizeInterface) !== null && _w$iAdvizeInterface !== void 0 ? _w$iAdvizeInterface : [];
        w.iAdvizeInterface.config = {
          sid: $config.public.iAdvizeId,
          lang: locale,
          explicitCookiesConsent: true
        };

        // Create the script element
        var script = document.createElement('script');
        script.id = 'iadvize-script';
        script.src = '//halc.iadvize.com/iadvize.js';
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;

        // Handle script load success
        script.onload = function () {
          if (w.iAdvizeInterface && typeof w.iAdvizeInterface.set === 'function') {
            resolve(true);
          } else {
            console.warn('IAdvize API not initialized properly despite script load');
            resolve(false); // Fallback mode if API is not functional
          }
        };

        // Handle script load error
        script.onerror = function () {
          console.error('IAdvize script could not be loaded; running in degraded mode');
          resolve(false); // Fallback mode on error
        };

        // Append the script to the document
        document.head.appendChild(script);

        // Set up consent handling
        onConsent('iAdvize', function () {
          pushIAdvizeEvent(function (iAdvize) {
            if (iAdvize && typeof iAdvize.set === 'function') {
              iAdvize.set('visitor:cookiesConsent', true);
            } else {
              console.warn('iAdvize API not available for setting cookies consent');
            }
          });
        });
      } catch (error) {
        $sentry === null || $sentry === void 0 ? void 0 : $sentry.setContext('error for iAdvize', error);
        $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(new Error('iAdvizeError: user uses vpn or connection problem between site and IPs for iadvice'));
        console.error('Error loading IAdvize script:', error);
        resolve(false);
      }
    });
  }

  /**
   * Pushes an event to the IAdvize interface queue.
   * @param handler - Function that executes the event logic.
   */
  function pushIAdvizeEvent(handler) {
    var w = window;
    if (!w.iAdvizeInterface) {
      console.error('Cannot send iAdvize events before initialization.');
      return;
    }
    w.iAdvizeInterface.push(handler);
  }

  /**
   * Sets custom data for IAdvize if the interface is available.
   * @param obj - Object containing custom data to pass to IAdvize.
   */
  function setIAdvizeData() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var w = window;
    if (!w.iAdvizeInterface) {
      console.warn('IAdvize script is not loaded. Custom data cannot be set.');
      return;
    }
    w.idzCustomData = obj;
  }
  return {
    loadIAdvize: loadIAdvize,
    pushIAdvizeEvent: pushIAdvizeEvent,
    setIAdvizeData: setIAdvizeData
  };
}